import React, { useState, useMemo, useEffect } from 'react';
import styled, { keyframes, css } from 'styled-components';
import Image from 'next/image';
import { resolvePath } from '@/utils/resolvePath';
import { useRouter } from 'next/router';
import { imageLoader } from '@/utils/imageLoader';
import { authenticationService } from '@/services/authentication_service';
import { getLoginUrl } from '@/utils/getLoginUrl';
import Router from '@/components/common/router';
import { appendCurrentParamsToRoute } from '@/components/fakeDoor/utils';
import NewJourneyModal from '@/components/fakeDoor/components/garageLandingPage/components/resumeJourneyModal';
import { trackEventAPI } from '@/analytics/middleware';
import { TAP_BTN_CATEGORY_SELECTED } from '@/analytics/events';
import { APPOINTMENT_CARD_TYPE, USER_POLICY_TYPE } from '@/constants/enums';
import { ACTIVE_BOOKING } from './messages';
import toast from 'react-hot-toast';
import {
    sortServicesByCouponAvailability,
    getMatchingCouponsByServiceType,
} from '@/utils/rewards';
import { REWARD_FALLBACK_MESSAGE } from '@/constants/index';
import { getCouponMessage } from '@/utils';
import RewardIcon from '@/public/images/reward.svg';
import { SESSION_STORAGE_KEYS } from '@/constants/storageKeys';
import { getRewardValue } from '@/utils/rewards';

const CarServices = (props: any) => {
    const {
        heading,
        servicesImages,
        subText,
        logo,
        logos,
        isLandingPage = false,
        cardData,
        rewardAvailableMessage,
        garageId,
        pincode,
        rewardDetails,
        isLoggedInServerSide,
        userPolicyType,
        policyHolderDescription,
        nonPolicyHolderDescription,
        appointmentData,
    } = props;
    console.log('cardData', cardData);
    const router = useRouter();
    const isLoggedIn = authenticationService.isLoggedIn();
    const [confirmCancelModal, setConfirmCancelModal] = useState(false);
    const [currentUrl, setCurrentUrl] = useState('');
    const [isHighlightingActive, setIsHighlightingActive] = useState(false);
    // const [isBannerShown, setIsBannerShown] = useState(false);
    const isGarageIdAvailable = !!garageId;
    const isPincodeAvailable = !!pincode;
    // const rewardMessage = rewardAvailableMessage || REWARD_FALLBACK_MESSAGE;
    // const isLoggedOutWithGarage = isGarageIdAvailable && !isLoggedIn;

    // const carouselJSONLd = useMemo(
    //     () => ({
    //         '@context': 'https://schema.org',
    //         '@type': 'BreadcrumbList',
    //         itemListElement: servicesImages?.map((l: any, i: number) => ({
    //             '@type': 'ListItem',
    //             position: i + 1,
    //             name: l?.text,
    //         })),
    //         itemListOrder: 'https://schema.org/ItemListOrderDescending',
    //         name: heading,
    //     }),
    //     []
    // );

    const sortedServicesImages = useMemo(() => {
        return sortServicesByCouponAvailability(servicesImages, rewardDetails);
    }, [servicesImages, rewardDetails]);

    useEffect(() => {
        const bannerAlreadyShown =
            sessionStorage.getItem(SESSION_STORAGE_KEYS.BANNER_SHOWN) ===
            'true';
        if (bannerAlreadyShown) {
            // setIsBannerShown(false);
            // setIsHighlightingActive(false);
            return;
        }

        const hasCouponCards = sortedServicesImages.some(
            (serviceImage) => serviceImage.isCouponAvailable === true
        );

        if (
            hasCouponCards &&
            isLoggedInServerSide &&
            isGarageIdAvailable &&
            isPincodeAvailable &&
            !appointmentData?.appointment_id
        ) {
            setIsHighlightingActive(true);
            // setIsBannerShown(true);
            const timer = setTimeout(() => {
                setIsHighlightingActive(false);
                sessionStorage.setItem(
                    SESSION_STORAGE_KEYS.BANNER_SHOWN,
                    'true'
                );
            }, 4000);

            return () => {
                clearTimeout(timer);
            };
        }
    }, [sortedServicesImages]);

    const carBrandsList: any =
        logos?.data?.map((l: any) => {
            return l?.attributes?.url;
        }) || [];

    const handleClick = async (
        redirectUrl: string,
        serviceType?: string,
        isYes?: boolean
    ) => {
        if (serviceType) {
            sessionStorage.setItem(
                SESSION_STORAGE_KEYS.SERVICE_TYPE,
                serviceType
            );
        }
        if (!isYes) {
            trackEventAPI({
                event_name: TAP_BTN_CATEGORY_SELECTED,
                customAttributes: {
                    category_selected: serviceType,
                },
                isFakeDoor: true, // You can change this or add more attributes if needed
            });
        }
        let route;
        // if (redirectUrl === 'periodic') {
        //     route = `${ROUTEMAP.LOCATION_VEHICLE_CHECK}?redirect_from=${redirectUrl}`;
        //     //Router.push(`${route}`);
        // } else if (redirectUrl === 'specific-repair') {
        //     route = ROUTEMAP.GARAGE_SPECIFIC_REPAIR;
        //     //Router.push(ROUTEMAP.GARAGE_SPECIFIC_REPAIR);
        // } else {
        //     route = ROUTEMAP.GARAGE_NOT_SURE_ISSUE;
        //     //Router.push(ROUTEMAP.GARAGE_NOT_SURE_ISSUE);
        // }

        if (isLoggedIn) {
            if (isYes) {
                Router.push(redirectUrl);
                return;
            }
            if (
                cardData?.cardType === APPOINTMENT_CARD_TYPE.CONTACT_US ||
                cardData?.cardType === APPOINTMENT_CARD_TYPE.RESUME_BOOKING ||
                cardData?.cardType === APPOINTMENT_CARD_TYPE.SELECT_SLOT
            ) {
                setConfirmCancelModal(true);
                setCurrentUrl(redirectUrl);
                return;
            }
            if (cardData?.ctaName) {
                if (cardData.paymentLink) {
                    setCurrentUrl(redirectUrl);
                    setConfirmCancelModal(true);
                }
            } else {
                Router.push(redirectUrl);
            }
            if (cardData.cardType === APPOINTMENT_CARD_TYPE.VIEW_BOOKING) {
                toast(ACTIVE_BOOKING);
            }
        } else {
            // if (isGarageIdAvailable) {
            //     sessionStorage.setItem(
            //         SESSION_STORAGE_KEYS.BANNER_SHOWN,
            //         'true'
            //     );
            // }
            const targetPath = router.asPath;
            const redirectPath = appendCurrentParamsToRoute(targetPath);
            window.location.href = getLoginUrl(redirectPath);
        }
    };
    return (
        <>
            {isHighlightingActive && <OverlayBackdrop />}
            <CarServicesWrapper id="services-section">
                {/* <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(carouselJSONLd),
                    }}
                />
            </Head> */}
                {/* <Image
                src={}
                width={100}
                height={100}
            /> */}
                {/* {logo ? (
                    <ImageTextWrapper>
                        <ImageWrapper>
                            <Image
                                loader={imageLoader}
                                src={
                                    logo?.company_image_url?.data?.attributes
                                        ?.url
                                }
                                layout="fill"
                                alt="Navigation"
                                objectFit="cover"
                            />
                        </ImageWrapper>

                        <CarServicesHeading
                            dangerouslySetInnerHTML={{ __html: heading }}
                        />
                    </ImageTextWrapper>
                ) : (
                    <CarServicesHeading
                        isLandingPage={isLandingPage}
                        dangerouslySetInnerHTML={{ __html: heading }}
                    />
                )}

                {subText && <CarServicesSubText>{subText}</CarServicesSubText>} */}
                <ServicesLogosWrapper>
                    {(() => {
                        const couponCards = sortedServicesImages.filter(
                            (serviceImage: any) =>
                                serviceImage?.isCouponAvailable === true
                        );
                        const nonCouponCards = sortedServicesImages.filter(
                            (serviceImage: any) =>
                                serviceImage?.isCouponAvailable !== true
                        );

                        const renderServiceCard = (
                            servicesImage: any,
                            index: number
                        ) => {
                            const isHighlighted =
                                isHighlightingActive &&
                                servicesImage?.isCouponAvailable === true;
                            return (
                                <ServicesCardWrapper
                                    key={`service-card-${index}`}
                                    isHighlighted={isHighlighted}
                                    {...(servicesImage.redirectionUrl && {
                                        onClick: (e) => {
                                            e.preventDefault();
                                            handleClick(
                                                servicesImage?.redirectionUrl,
                                                servicesImage?.key
                                            );
                                        },
                                    })}
                                >
                                    <ServicesCardBodyWrapper>
                                        <ServicesCardImageWrapper>
                                            <img
                                                src={
                                                    servicesImage?.imageUrl
                                                        ?.data?.attributes?.url
                                                }
                                                width={105}
                                                height={124}
                                            />
                                        </ServicesCardImageWrapper>
                                        {/* <ServicesCardBodyWrapper> */}
                                        <ServicesCardBodyContainer>
                                            <ServiceCardContentContainer>
                                                <ServiceTitleDescriptionContainer>
                                                    <ServicesCardTitleContainer>
                                                        <ServiceTitle>
                                                            {
                                                                servicesImage?.text
                                                            }
                                                        </ServiceTitle>
                                                        <Image
                                                            src={resolvePath(
                                                                '/images/seo/Arrow_right_black.svg'
                                                            )}
                                                            width={20}
                                                            height={20}
                                                        />
                                                    </ServicesCardTitleContainer>
                                                    <ServiceDescription>
                                                        {
                                                            servicesImage?.description
                                                        }
                                                    </ServiceDescription>
                                                </ServiceTitleDescriptionContainer>
                                                {servicesImage?.isCouponAvailable ===
                                                    true && (
                                                    <PricingContainer>
                                                        <CouponValueWrapper>
                                                            <CouponValueText>
                                                                {getRewardValue(
                                                                    servicesImage,
                                                                    rewardDetails
                                                                )}
                                                            </CouponValueText>
                                                        </CouponValueWrapper>
                                                        <DefaultValueText>
                                                            {
                                                                servicesImage?.defaultPricingAmount
                                                            }
                                                        </DefaultValueText>
                                                    </PricingContainer>
                                                )}
                                                {servicesImage?.isCouponAvailable ===
                                                    false &&
                                                    servicesImage?.isDefaultedCouponExperience ===
                                                        true &&
                                                    !(
                                                        cardData?.cardType ===
                                                        APPOINTMENT_CARD_TYPE.VIEW_BOOKING
                                                    ) && (
                                                        <DefaultedCouponExperienceContainer>
                                                            <RewardIcon />
                                                            <DefaultedCouponExperienceText>
                                                                {
                                                                    servicesImage?.defaultedCouponExperienceText
                                                                }
                                                            </DefaultedCouponExperienceText>
                                                        </DefaultedCouponExperienceContainer>
                                                    )}
                                            </ServiceCardContentContainer>
                                            <ServiceCardPointsContainer>
                                                <ServiceCardPointsMarqueeWrapper>
                                                    <ServiceCardPointsMarqueeContent
                                                        pointCount={
                                                            servicesImage?.subText?.split(
                                                                ',,'
                                                            ).length || 0
                                                        }
                                                    >
                                                        {servicesImage?.subText
                                                            ?.split(',,')
                                                            .map(
                                                                (
                                                                    data: any,
                                                                    idx: number
                                                                ) => (
                                                                    <PointBody
                                                                        key={`point-${idx}`}
                                                                    >
                                                                        <ServiceCardPoints>
                                                                            {
                                                                                data
                                                                            }
                                                                        </ServiceCardPoints>
                                                                    </PointBody>
                                                                )
                                                            )}
                                                        {servicesImage?.subText
                                                            ?.split(',,')
                                                            .map(
                                                                (
                                                                    data: any,
                                                                    idx: number
                                                                ) => (
                                                                    <PointBody
                                                                        key={`point-duplicate-${idx}`}
                                                                    >
                                                                        <ServiceCardPoints>
                                                                            {
                                                                                data
                                                                            }
                                                                        </ServiceCardPoints>
                                                                    </PointBody>
                                                                )
                                                            )}
                                                    </ServiceCardPointsMarqueeContent>
                                                </ServiceCardPointsMarqueeWrapper>
                                            </ServiceCardPointsContainer>
                                        </ServicesCardBodyContainer>
                                    </ServicesCardBodyWrapper>
                                </ServicesCardWrapper>
                            );
                        };

                        return (
                            <CarServicesContainer>
                                {couponCards.length > 0 && (
                                    <CouponCardsContainer
                                        userPolicyType={userPolicyType}
                                        isHighlighted={isHighlightingActive}
                                    >
                                        <CouponTextWrapper>
                                            {userPolicyType ===
                                            USER_POLICY_TYPE.PH ? (
                                                <Image
                                                    src={resolvePath(
                                                        '/images/ackodrive/ph-coupon-text.svg'
                                                    )}
                                                    alt="Policy Holder Coupon"
                                                    width={24}
                                                    height={24}
                                                />
                                            ) : (
                                                <Image
                                                    src={resolvePath(
                                                        '/images/ackodrive/nph-coupon-text.svg'
                                                    )}
                                                    alt="Non Policy Holder Coupon"
                                                    width={24}
                                                    height={24}
                                                />
                                            )}
                                            <UserTypeDescription
                                                userPolicyType={userPolicyType}
                                                // isHighlighted={
                                                //     isHighlightingActive
                                                // }
                                            >
                                                {userPolicyType ===
                                                USER_POLICY_TYPE.PH
                                                    ? policyHolderDescription
                                                    : nonPolicyHolderDescription}
                                            </UserTypeDescription>
                                        </CouponTextWrapper>
                                        {couponCards.map(
                                            (
                                                servicesImage: any,
                                                index: number
                                            ) =>
                                                renderServiceCard(
                                                    servicesImage,
                                                    index
                                                )
                                        )}
                                    </CouponCardsContainer>
                                )}
                                <NonCouponCardsContainer>
                                    {nonCouponCards.map(
                                        (servicesImage: any, index: number) =>
                                            renderServiceCard(
                                                servicesImage,
                                                couponCards.length + index
                                            )
                                    )}
                                </NonCouponCardsContainer>
                            </CarServicesContainer>
                        );
                    })()}
                    {carBrandsList?.length > 0 && (
                        <MarqueeWrapper>
                            <MarqueeContainer> </MarqueeContainer>
                            <BrandWrappeMarqueerDiv
                                widthLength={48 * logos?.data?.length}
                            >
                                {carBrandsList?.map((Icon: any) => {
                                    return (
                                        <BankLogo>
                                            <div
                                                style={{
                                                    width: '32px',
                                                    height: '32px',
                                                }}
                                            >
                                                <Image
                                                    src={Icon}
                                                    width={32}
                                                    height={32}
                                                    alt="Logo"
                                                />
                                            </div>
                                        </BankLogo>
                                    );
                                })}
                                {carBrandsList?.map((Icon: any) => {
                                    return (
                                        <BankLogo>
                                            <div
                                                style={{
                                                    width: '32px',
                                                    height: '32px',
                                                }}
                                            >
                                                <Image
                                                    src={Icon}
                                                    width={32}
                                                    height={32}
                                                    alt="Logo"
                                                />
                                            </div>
                                        </BankLogo>
                                    );
                                })}
                            </BrandWrappeMarqueerDiv>
                        </MarqueeWrapper>
                    )}
                </ServicesLogosWrapper>
                {/* <ServicesWrapper>
                <ServiceDataWrapper>
                    {servicesImages.map((servicesImage: any, index: number) => {
                        if (index > 2) {
                            return;
                        }
                        return (
                            <ServiceWrapper>
                                <Image
                                    src={
                                        servicesImage.imageUrl.data.attributes
                                            .url
                                    }
                                    width={100}
                                    height={100}
                                />
                                <ServiceText>{servicesImage.text}</ServiceText>
                            </ServiceWrapper>
                        );
                    })}
                </ServiceDataWrapper>
                <ServiceDataWrapper>
                    {servicesImages.map((servicesImage: any, index: number) => {
                        if (index < 3) {
                            return;
                        }
                        return (
                            <ServiceWrapper>
                                <Image
                                    src={
                                        servicesImage.imageUrl.data.attributes
                                            .url
                                    }
                                    width={100}
                                    height={100}
                                />
                                <ServiceText>{servicesImage.text}</ServiceText>
                            </ServiceWrapper>
                        );
                    })}
                </ServiceDataWrapper>
            </ServicesWrapper> */}
            </CarServicesWrapper>
            <NewJourneyModal
                onClose={() => {
                    setCurrentUrl('');
                    setConfirmCancelModal(false);
                }}
                ctaClick={() => handleClick(currentUrl, '', true)}
                show={confirmCancelModal}
            />
        </>
    );
};

export default CarServices;

const BankLogo = styled.span``;

const marqueeTop = (widthLength?: any) => keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-${widthLength}px);
  }
`;

const BrandWrappeMarqueerDiv = styled.div<{ widthLength?: any }>`
    display: flex;
    height: 36px;
    gap: 16px;
    animation: ${(props) => marqueeTop(props.widthLength)} 5s linear infinite;
    padding: 15px 0 12px;
`;

const MarqueeWrapper = styled.div`
    position: relative;
    width: 100%;
    margin-left: -16px;
    margin-right: -16px;
    overflow: hidden;
`;

const MarqueeContainer = styled.div`
    width: 100%;
    height: 60px;
    background: linear-gradient(
        90deg,
        #f4f4f4 0%,
        rgba(244, 244, 244, 0) 20%,
        rgba(244, 244, 244, 0) 80%,
        #f4f4f4 100%
    );
    position: absolute;
    z-index: 99;
`;

const PointBody = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    white-space: nowrap;
    flex-shrink: 0;
    border-radius: 24px;
    background: #f5f5f5;
    padding: 8px;
`;

const ServiceCardPoints = styled.div`
    color: #121212;
    font-family: 'Euclid Circular B';
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
`;

const ServiceCardPointsContainer = styled.div`
    display: flex;
    max-width: 220px;
    min-height: 24px;
    justify-content: flex-end;
    align-items: flex-start;
    gap: 8px;
    overflow: hidden;
`;

const ServiceCardPointsMarqueeWrapper = styled.div`
    position: relative;
    width: 100%;
    overflow: hidden;
`;

const marqueePoints = () => keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const ServiceCardPointsMarqueeContent = styled.div<{
    pointCount: number;
}>`
    display: flex;
    align-items: center;
    gap: 4px;
    width: fit-content;
    animation: ${marqueePoints()} 10s linear infinite;
    will-change: transform;
`;

const ServiceTitle = styled.div`
    color: var(--Neutral-N600, #040222);
    font-family: 'Euclid Circular B';
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
`;

const ServicesCardTitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    align-self: stretch;
`;

const ServicesCardBodyWrapper = styled.div`
    display: flex;
    width: 100%;
    min-width: 280px;
    justify-content: space-between;
    gap: 16px;
    overflow: hidden;
`;

const ServicesCardBodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    flex: 1;
    overflow: hidden;
`;

const ServiceCardContentContainer = styled.div`
    display: flex;
    min-width: 170px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
`;

const ServiceTitleDescriptionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-self: stretch;
`;

const ServicesCardImageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    flex-shrink: 0;
    width: 105px;
    img {
        border-radius: 12px;
        object-fit: cover;
    }
`;

const ServicesCardWrapper = styled.div<{ isHighlighted?: boolean }>`
    display: flex;
    min-width: 296px;
    max-width: 100%;
    padding: 8px;
    align-items: center;
    align-self: stretch;
    border-radius: 12px;
    border: 1px solid #f5f5f5;
    background: #fff;
    overflow: hidden;
    cursor: pointer;
    position: relative;
    transition:
        z-index 0.3s ease,
        box-shadow 0.3s ease;
    ${({ isHighlighted }) =>
        isHighlighted &&
        `
        z-index: 1000;
        box-shadow: 0px 12px 16px 0px rgba(0, 0, 0, 0.2);
    `}
`;

const ServicesLogosWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    align-self: stretch;
`;

const ImageTextWrapper = styled.div`
    display: flex;
    gap: 8px;
`;

const ImageWrapper = styled.div`
    position: relative;
    width: 48px;
    min-width: 48px;
    height: 48px;
    background: #f5f5f5;
    border-radius: 50%;
`;

const CarServicesWrapper = styled.div`
    display: flex;
    padding: 20px 16px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    align-self: stretch;
`;

const CarServicesHeading = styled.h1<{ isLandingPage?: boolean }>`
    color: #121212;
    font-family: 'Euclid Circular B';
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px;
    letter-spacing: -0.1px;
    align-self: stretch;
`;

const CarServicesSubText = styled.div`
    color: #4b4b4b;
    font-family: 'Euclid Circular B';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    align-self: stretch;
`;

const ServiceWrapper = styled.div`
    width: calc((100% - 24px) / 3);
`;

const ServiceDataWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
`;

const ServiceText = styled.div`
    color: #4b4b4b;
    font-family: 'Euclid Circular B';
    font-style: normal;
    font-weight: 500;
    text-align: center;
    font-size: 12px;
    line-height: 18px;
`;

const ServiceDescription = styled.div`
    color: #757575;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    align-self: stretch;
`;

const UserTypeDescription = styled.div<{
    userPolicyType?: string;
    isHighlighted?: boolean;
}>`
    color: ${({ userPolicyType }) =>
        userPolicyType === USER_POLICY_TYPE.PH ? '#451999' : '#0B753E'};
    font-family: 'Euclid Circular B';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    ${({ isHighlighted }) =>
        isHighlighted &&
        `
        z-index: 1000;
        box-shadow: 0px 12px 16px 0px rgba(0, 0, 0, 0.2);
    `}
`;

const CouponCardsContainer = styled.div<{
    userPolicyType?: string;
    isHighlighted?: boolean;
}>`
    display: flex;
    padding: 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    align-self: stretch;
    border-radius: 20px;
    background: ${({ userPolicyType }) =>
        userPolicyType === USER_POLICY_TYPE.PH ? '#EFE9FB' : '#EBFBEE'};
    ${({ isHighlighted }) =>
        isHighlighted &&
        `
        z-index: 1000;
        box-shadow: 0px 12px 16px 0px rgba(0, 0, 0, 0.2);
    `}
`;

const NonCouponCardsContainer = styled.div`
    display: flex;
    // padding: 0 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    align-self: stretch;
    border-radius: 20px;
`;

const CouponTextWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    align-self: stretch;
`;

const OverlayBackdrop = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    animation: fadeIn 0.3s ease-in;
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

const PricingContainer = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
`;

const CouponValueWrapper = styled.div`
    min-width: 66.709px;
    height: 24px;
    flex-shrink: 0;
    border-radius: 2px;
    background: #0fa457;
    box-shadow: 2px 2px 0 0 #54e299;
    padding-top: 4px;
`;

const CouponValueText = styled.div`
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    text-align: center;
`;

const DefaultValueText = styled.div`
    color: var(--Text-Disabled-grey200, #a6a6a6);
    font-family: 'Euclid Circular B';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    text-decoration: line-through;
`;

const DefaultedCouponExperienceContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    width: 167px;
    height: 24px;
    flex-shrink: 0;
    border-radius: 4px;
    background: var(--Green-G50, #ebfbee);
`;

const DefaultedCouponExperienceText = styled.div`
    color: var(--Green-G400, #0b753e);
    font-size: 10px;
    font-weight: 500;
    line-height: 14px;
`;

const CarServicesContainer = styled.div`
    display: flex;
    min-width: 320px;
    max-width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
`;
